<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="公众号名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入公众号名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公众号原始id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['accountId', validatorRules.accountId]" placeholder="请输入公众号原始id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="appid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['appid', validatorRules.appid]" placeholder="请输入appid"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="secret" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['secret', validatorRules.secret]" placeholder="请输入secret"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="token" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['token', validatorRules.token]" placeholder="请输入token"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公众号描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remark', validatorRules.remark]" rows="4" placeholder="请输入公众号描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="valid_status" placeholder="请选择状态"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'WxAccountForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {
            rules: [
              { required: true, message: '请输入公众号名称!'},
            ]
          },
          accountId: {
            rules: [
              { required: true, message: '请输入公众号原始id!'},
            ]
          },
          appid: {
            rules: [
              { required: true, message: '请输入appid!'},
            ]
          },
          secret: {
            rules: [
              { required: true, message: '请输入secret!'},
            ]
          },
          token: {
            rules: [
              { required: true, message: '请输入token!'},
            ]
          },
          remark: {
            rules: [
              { required: true, message: '请输入公众号描述!'},
            ]
          },
          status: {
            rules: [
              { required: true, message: '请输入状态!'},
            ]
          },
        },
        url: {
          add: "/wx/wxAccount/add",
          edit: "/wx/wxAccount/edit",
          queryById: "/wx/wxAccount/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name','accountId','appid','secret','token','remark','addTokenTime','status','wxRespUrl','createBy','createTime','updateBy','updateTime'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','accountId','appid','secret','token','remark','addTokenTime','status','wxRespUrl','createBy','createTime','updateBy','updateTime'))
      },
    }
  }
</script>